module.exports = __webpack_public_path__ + "static/media/dark.2d966c9e.PNG";